import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatRelativeDate } from '../utils';

const iconFor = (type) => {
  switch (String(type || '').toLowerCase()) {
    case 'search':
      return { icon: 'Search', color: 'text-sky-600 bg-sky-50' };
    case 'save':
    case 'favourite':
    case 'favorite':
      return { icon: 'Heart', color: 'text-rose-600 bg-rose-50' };
    case 'view':
      return { icon: 'Eye', color: 'text-emerald-600 bg-emerald-50' };
    case 'tour':
    case 'booking':
      return { icon: 'Calendar', color: 'text-amber-700 bg-amber-50' };
    case 'alert':
      return { icon: 'Bell', color: 'text-orange-600 bg-orange-50' };
    case 'need':
    case 'request':
      return { icon: 'ClipboardList', color: 'text-violet-600 bg-violet-50' };
    case 'contact':
      return { icon: 'MessageCircle', color: 'text-indigo-600 bg-indigo-50' };
    default:
      return { icon: 'Activity', color: 'text-slate-600 bg-slate-100' };
  }
};

const ActivityFeed = ({ activities = [], isLoading, fallbackItems = [] }) => {
  const list =
    Array.isArray(activities) && activities.length
      ? activities
      : Array.isArray(fallbackItems)
        ? fallbackItems
        : [];

  return (
    <section className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100">
        <h2 className="text-base font-semibold text-slate-900">Recent activity</h2>
        <p className="text-xs text-slate-500 mt-0.5">What you have been doing on HireBroker</p>
      </div>

      {isLoading ? (
        <div className="p-5 space-y-3">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-12 rounded-lg bg-slate-100 animate-pulse" />
          ))}
        </div>
      ) : list.length === 0 ? (
        <div className="text-center py-10 px-5">
          <Icon name="Activity" size={28} className="mx-auto text-slate-300 mb-2" />
          <p className="text-sm text-slate-600">No recent activity yet</p>
          <p className="text-xs text-slate-400 mt-1">
            Search, save properties, or post a request to get started.
          </p>
        </div>
      ) : (
        <ul className="divide-y divide-slate-100 max-h-[420px] overflow-y-auto">
          {list.slice(0, 10).map((activity, index) => {
            const meta = iconFor(activity.type || activity.kind);
            const title =
              activity.action ||
              activity.title ||
              activity.description ||
              activity.message ||
              'Activity';
            const detail =
              activity.propertyTitle ||
              activity.property_title ||
              activity.location ||
              activity.detail ||
              '';
            const time =
              activity.timestamp || activity.created_at || activity.time || activity.date;
            return (
              <li key={activity.id || `${index}-${title}`} className="flex items-start gap-3 px-5 py-3.5">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${meta.color}`}
                >
                  <Icon name={meta.icon} size={14} />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-slate-900">
                    <span className="font-medium">{title}</span>
                    {detail ? (
                      <span className="text-slate-500"> · {detail}</span>
                    ) : null}
                  </p>
                  {time && (
                    <p className="text-[11px] text-slate-400 mt-1">{formatRelativeDate(time)}</p>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};

export default ActivityFeed;
